import React from 'react';
import moment from 'moment';
import BlockSelectField from '@common/components/FormElements/BlockSelectField';

const optionsForPerDateTime = (options) =>
  options.map((option, index) => ({
    label: `${moment(option.startDate).format('MMM DD')} - ${option?.time?.substr(0, 5)}`,
    value: index,
  }));

export const PerDateTime = ({ field, options }) => {
  return (
    <BlockSelectField
      onChange={(value) => {
        field.onChange(value);
      }}
      value={field.value}
      options={optionsForPerDateTime(options)}
    />
  );
};
